import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import {  injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { checkPhone } from "../../Settings/_redux/professionals/professionalsCrud";
import QRCode from "react-qr-code";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  phone: "",
};

function ScanQR(props) {
  const [loading, setLoading] = useState(false);
  const [QRFound, setQRFound] = useState(false);
  const [message, setMessage] = useState('');
  const [verifiedPhone, setVerifiedPhone] = useState('');
  const CheckQRSchema = Yup.object().shape({
    phone: Yup.string()
      .min(9, 'Minimum 10 characters')
      .max(15, 'Maximum 15 characters')
      .required('Phone is required'),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };



  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CheckQRSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {

        

    console.log('values', values);
      enableLoading();
      checkPhone(values.phone)
        .then((resp) => {
            if(resp.data.result_code === 1){
                setVerifiedPhone(resp.data.result.phone);
                setQRFound(true);
                setMessage('');
            } else{
                setQRFound(false);
                setMessage('Your Record does not exist');
            }
            disableLoading();
        })
        .catch(() => {
            disableLoading();
            setSubmitting(false);
            setStatus({msg: 'Your Record does not exist', type: 'danger'});
        }).finally(() => {
            disableLoading();
            setSubmitting(false);
        });
    },
    });

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-0">
        <h3 className="font-size-h1">View Your QR Code</h3>
        <p className="text-muted font-weight-bold">Please enter your phone number to generate a QR code</p>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        <div className="form-group fv-plugins-icon-container">
          <input
            placeholder="Your phone number"
            type="text"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "phone"
            )}`}
            name="phone"
            autoComplete="phone"
            {...formik.getFieldProps("phone")}
          />
          {formik.touched.phone && formik.errors.phone ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.phone}</div>
            </div>
          ) : null}
        </div>
        {message && <div className="alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{message}</div>
        </div>}
        {/*A box to place the QR CODE in case the searched phone number is found. Hide until the phone number is found */}
        {QRFound && <div className="d-flex align-items-center justify-content-center flex-wrap mb-6">
          <div className="border border-white shadow-sm p-5">
            <QRCode id="qrcodesvg" value={verifiedPhone} size={180} />
          </div>
          {/* add download button to download QR code image */}
            <div className="d-flex align-items-center justify-content-center flex-wrap p-5 mb-6">
                <button className="btn btn-primary btn-block font-weight-bold px-9 py-4 mb-3- ml-2-" onClick={() => {
                    const svg = document.getElementById('qrcodesvg');
                    const canvas = document.createElement('canvas');
                    canvas.width = 200;
                    canvas.height = 200;
                    const ctx = canvas.getContext('2d');
                    const img = new Image();
                    img.onload = () => {
                        ctx.drawImage(img, 0, 0);
                        const a = document.createElement('a');
                        a.download = 'QRCode.png';
                        a.href = canvas.toDataURL('image/png');
                        a.click();
                    };
                    img.src = 'data:image/svg+xml;base64,' + btoa(svg.outerHTML);
                }}>
                <span>Download QR Code</span>
                </button>
            </div>
        </div>}

        <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={`btn btn-primary btn-block font-weight-bold px-9 py-4 mb-3- ml-2-`}
          >
            <span>View QR Code</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>
        </div>
        <div className="form-group d-flex flex-wrap align-items-end justify-content-end">
          <Link to="/auth/login" className="text-dark-50 font-weight-bold text-hover-primary my- ml-2" id="kt_login_forgot">
            Back to login
          </Link>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ScanQR));
